import { render, staticRenderFns } from "./perfilesAdd.vue?vue&type=template&id=7ab18ea6&"
import script from "./perfilesAdd.vue?vue&type=script&lang=js&"
export * from "./perfilesAdd.vue?vue&type=script&lang=js&"
import style0 from "./perfilesAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports